export default __webpack_public_path__ + "static/media/img8.43398ad3.jpg";